import cdn from "@shared/utils/urls/cdn";
import url from "@shared/utils/urls/url";
import clip from "text-clipper";
import { PublicMembershipGroupSerializer } from "../types";

/**
 * Creates a rich schema version of the event object returned from the getPublicEvent and getPublicEventWithSlug api calls
 * @param inputMembershipGroup event object
 * @return {JSON string}
 */
export const createRichMembershipGroupSchema = (
  inputMembershipGroup: PublicMembershipGroupSerializer,
  inputSlug?: string
): string => {
  const mg = inputMembershipGroup;

  const membershipGroupSchema = {
    "@context": "http://schema.org/",
    "@type": "ProgramMembership",
    identifier: mg.id,
    name: mg.name,
    description: mg.description
      ? clip(mg.description, mg.description.length, {
          html: true,
          stripTags: true,
        })
      : `${mg.name} - ${mg.venue?.name}`,
    image: mg.image || cdn("images/default-banner.png"),
    url: inputSlug && url("m/{slug}", { slug: inputSlug }),
    hostingOrganization: {
      "@context": "http://schema.org/",
      "@type": "Organization",
      identifier: mg.venue?.id,
      name: mg.venue?.name,
    },
  };

  return JSON.stringify(membershipGroupSchema);
};
